import { useEffect, useState } from "react";
import { CiSettings } from "react-icons/ci";
import { FcHome } from "react-icons/fc";
import { getAccessToken } from "../../storage/storage";
import { VscDebugDisconnect } from "react-icons/vsc";
import axios from "axios";
import { useNavigate,useLocation, useParams  } from "react-router-dom";

export default function LodgifyIntigration() {
  const token = getAccessToken();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { case: caseParam } = useParams();
  const Navigate = useNavigate();
  const location = useLocation();

  // Access the passed data
  const lodgifyData = location.state?.lodgifyData;
  useEffect(() => {
    console.log("Data "+lodgifyData);
  }, []);
  return (
    <div className="max-w-2xl mx-auto space-y-6 my-10 bg-white shadow-lg p-6 rounded-lg">
      <h1 className="md:text-3xl text-lg font-bold text-[#586989] mb-4">
        <div className="flex items-center gap-2 text-lg font-bold"> <CiSettings /> Channel Manager Integration </div>
      </h1>

      {/* Display success message if data was passed */}
      {lodgifyData && (
        <div className="text-smbg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
          Successfully connected to PMS!
        </div>
      )}

      <p className="text-gray-600 mb-6 text-start text-sm">
        Connect your property management system to automatically sync bookings and streamline your cleaning operations.
      </p>

      <div><h1 className="md:text-lg text-lg font-bold text-[#586989] mb-4">
        Available Integrations
      </h1></div>

      <div className="bg-white p-4 rounded-lg shadow border border-[#586989]">
        <div className="flex items-center justify-between">
          <div >
            <div className="flex items-center">
              <div className=""> < FcHome size={32} /></div>
              <div className="ml-2 mb-2">
                <h2 className=" text-sm font-semibold">Lodgify</h2>
                <p className="text-sm">12000+ users worldwide</p>
              </div>
            </div>
          </div>
        </div>
        <p className="text-sm ">Complete property management platform with multi-channel distribution</p>
        <div className="flex items-center justify-between">
          <ul className="list-disc pl-4 mt-2">
            <li className="text-sm ">
              Real-time sync
            </li>
            <li className="text-sm ">
              Property import
            </li>
            <li className="text-sm ">
              Guest data sync
            </li>
          </ul>
          <div>
            <button
              className="bg-[#586989] text-white px-6 py-3 rounded-md md:flex items-center justify-center hidden"
              onClick={() => Navigate( caseParam ? `/lodgify-connect/${caseParam}` : "/lodgify-connect")}
            >
              <VscDebugDisconnect className="mr-2" /> Connect
            </button>
          </div>
        </div>
      </div>

      <div className="border border-[#586989] rounded-md p-2 flex gap-2">
        <span className="ml-0 text-black">&#9432;</span>
        <div className="text-sm text-black text-opacity-50">
          <strong>Important:</strong><span> integration requires active susbscription to yourchosen
            channel manager.You'll need administrator access to authorise the connection.
            Guest data will be handled in comlience with GDPR and privacy regulations.</span>
        </div>
      </div>

    </div>
  );
}
